import { render, staticRenderFns } from "./Honorarios.vue?vue&type=template&id=88cbeca6&scoped=true&"
import script from "./Honorarios.vue?vue&type=script&lang=js&"
export * from "./Honorarios.vue?vue&type=script&lang=js&"
import style0 from "./Honorarios.vue?vue&type=style&index=0&id=88cbeca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88cbeca6",
  null
  
)

export default component.exports